import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSafetyCustom = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 12 12",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.0781 2.61914V7.09863C10.0775 7.10359 10.0771 7.10991 10.0762 7.11719C10.0729 7.14256 10.0671 7.1816 10.0586 7.23242C10.0415 7.33434 10.0128 7.48284 9.96582 7.66211C9.87129 8.02247 9.70626 8.49916 9.42578 8.97168C8.87422 9.90062 7.87425 10.8281 6 10.8281C4.12575 10.8281 3.12578 9.90062 2.57422 8.97168C2.29374 8.49916 2.12871 8.02247 2.03418 7.66211C1.98717 7.48284 1.95849 7.33434 1.94141 7.23242C1.93289 7.1816 1.92712 7.14256 1.92383 7.11719C1.92288 7.10991 1.92247 7.10359 1.92188 7.09863V2.61914L6 1.19629L10.0781 2.61914Z",
		stroke: "currentColor",
		fill: "none",
		strokeWidth: .84375
	})]
});
const ForwardRef = forwardRef(SvgSafetyCustom);
export { ForwardRef as ReactComponent };
